import IconMTicket from "@Icons/ticket/IconMTicket";
import {Colors} from "@Styles/Colors.style";
import React from "react";

function IsMTicketBadge() {
    return (
        <span className="gb--badge-green">
            <IconMTicket fill={Colors.neutralDarkestColor}/>
            M Ticket
        </span>
    )
}

export default IsMTicketBadge